import type { TFunction } from 'i18next'
import type { TimelineEvent } from '../../../components/ui/HistoryTimeline'
import type { TicketRequestDetail } from '../types'
import { formatDate } from '../../../lib/datetime'

/**
 * Bir talebin **İşlem Geçmişi** olaylarını üretir (tek kaynak — 014 FR-009). Hem Talep Detay sayfası
 * hem liste satır-içi genişletme paneli bu fonksiyonu + paylaşılan `ui/HistoryTimeline` bileşenini
 * kullanır; böylece iki yerde birebir aynı geçmiş gösterilir (kopya mantık/drift önlenir).
 *
 * Her olay **tek satır**: başlık + tarih (kullanıcı bilgisi gösterilmez). (1) Oluşturuldu her zaman;
 * (2) Karar **yalnız karar verilmişse** eklenir — durum kendi tag rengiyle (Onaylandı/Reddedildi,
 * `statusId`) gösterilir; karar verilene kadar tek işlem görünür, "Karar bekleniyor" adımı yok. İşlem
 * Geçmişi ayrı tablo/uç değildir; talebin kendi alanlarından türetilir.
 */
export function ticketActivityEvents(detail: TicketRequestDetail, t: TFunction): TimelineEvent[] {
  const events: TimelineEvent[] = [
    {
      title: t('tickets.detail.history.created'),
      meta: formatDate(detail.creDate),
      state: 'done',
    },
  ]
  // Karar verildiyse: "Onay / Ret Kararı" yerine durumu kendi tag rengiyle (Onaylandı/Reddedildi) göster.
  if (detail.approveOrRejectTime != null) {
    events.push({
      title: detail.status?.name ?? '',
      statusId: detail.status?.id,
      meta: formatDate(detail.approveOrRejectTime),
      state: 'done',
    })
  }
  return events
}
